module["exports"] = [
  "(9##)###-##-##"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/phone_number/formats.js
// module id = 196
// module chunks = 0